<template>
  <div>
    <h1>Roles</h1>
    <b-table
        show-empty
        stacked="md"
        :items="getAllRoles"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        empty-text="No existen registros por mostrar"
        emptyFilteredText="No existen registros por mostrar"
      >
      <template v-slot:cell(acciones)="row">
        <router-link :to="{name: 'updateRole', params: row.item}"> <b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllRoles.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_ALL_ROLES = gql`
  query getAllRoles{
    getAllRoles{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      getAllRoles: [],
      fields: [
        // { key: 'id', label: 'Id' },
        { key: 'name', label: 'Nombre del rol administrador' },
        { key: 'acciones', label: 'Acciones' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
    }
  },
  apollo: {
    getAllRoles: {
      query: GET_ALL_ROLES,
      result ({ data }) {
        if (data.getAllRoles != null) {
          console.log(data.getAllRoles, 'roles')
          this.totalRows = data.getAllRoles.length
        }
      },
      context: headers(),
    },
  },
}
</script>
<style scoped>

</style>
